import { Component } from '@angular/core';

@Component({
  selector: 'app-web-integration-1',
  templateUrl: './web-integration-1.component.html',
})
export class WebIntegration1Component {

  constructor() {


    //window.location.href = "https://docsend.com/view/ridrp69k78r9cwdj";


  }

}
